import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, withRouter } from "react-router-dom";
import _ from "lodash";
import styled from "styled-components";
import { reduxForm } from "redux-form";
import { Translate } from "react-redux-i18n";
import Constants from "../../../AppConstants/Constants";
import Utilities from "../../../Helpers/Utilities";
import { PageTitle } from "../../../Components/Common/PageTitle";
import { getXsrfToken } from "../../../Store/Security/Actions"
import { logout } from "../../../Store/Account/Actions"
import { getOrderSummary, applyForLease } from "../../../Store/Checkout/Actions";

// region Styles
const CustomRow = styled.div`
    margin-bottom: 20px;
`;

const Button = styled.button`
    width: 225px;
`;

const CustomP = styled.p`
    line-height: 1.5em;
    font-size: 10pt;
`;

const PTitle = styled(CustomP)`
    color: #38a7c6;
    font-weight: bold;
    margin-bottom: 0;
`;

const PDescription = styled(CustomP)`
    font-weight: bold;
`;

const PDescriptionSmaller = styled(CustomP)`
    font-weight: bold;
    font-size: 8pt;
`;
// endregion

class DocuSign extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showLink: false
        };
    }

    componentWillMount() {
        const { orderSummary, getOrderSummary, logout } = this.props;

        if (!orderSummary || orderSummary.id === undefined) {
            getOrderSummary(() => {
                this.setState({ showLink: true });
            }, error => {
                if (error.response.data.toLowerCase() === "cart is empty") {
                    this.setState({ showLink: true });
                } else if (error.response.status === 401 || error.response.status === 403) {
                    logout();
                } else {
                    document.querySelector("#server-error-msg").textContent = error.response.data;
                    $("#server-error-modal").modal("show");
                }
            });
        } else {
            this.setState({ showLink: true });
        }
    }

    onLinkClick() {
        const { userInfo, getXsrfToken, applyForLease, orderSummary, history, config: { DOCUSIGN_BASE_URL } } = this.props;

        let subTotal = 0;
        let shipping = 0;
        let total = 0;

        if (orderSummary && orderSummary.items) {
            _.each(orderSummary.items, item => {
                if (!item.isRecurring) {
                    subTotal += item.subTotalValue;
                }
            });

            total = Utilities.convertToPrimaryStoreCurrency(subTotal + shipping);
        }

        const params = {
            contact1FirstName: userInfo.firstName,
            contact1LastName: userInfo.lastName,
            contact1Email: userInfo.email,
            // contact1Phone: userInfo.phone,
            companyEmail: userInfo.email,
            companyName: userInfo.companyName
            // EquipmentCost: total > 0 ? Utilities.formatNumber(total, 2, Constants.DEFAULT_LANGUAGE.code) : null
        };

        if (userInfo.addresses.length > 0) {
            // params.Address = userInfo.addresses[0].address1;
            // params.City = userInfo.addresses[0].city;
            params.companyStateOfOrg = userInfo.addresses[0].stateProvinceName;
            params.contact1Phone = userInfo.addresses[0].phoneNumber;
            // params.ZipCode = userInfo.addresses[0].zipPostalCode;
        }

        const queryString = Utilities.buildUrlQueryString(params);

        // eslint-disable-next-line no-undef
        window.open(`${DOCUSIGN_BASE_URL}`, "_blank");

        getXsrfToken(({ token }) => {
            const obj = { __RequestVerificationToken: token };

            applyForLease(obj, () => {
                history.push(Constants.ENDPOINTS.CART);
            });
        });
    }

    onLinkClickCan() {
        window.open("https://apply.cwbnationalleasing.com/?src=NjQAJ&apply=true&segment=Transportation", "_blank");
        return false;
    }

    render() {
        const { isWizard, config: { CDN } } = this.props;
        const { showLink } = this.state;

        return (
            <form className="container">
                <div className="row justify-content-around">
                    <div className="col-md-12">
                        <PageTitle title={"leaseApplication.title"} style={isWizard ? { paddingTop: 0 } : {}}/>
                    </div>
                </div>

                <div className="row justify-content-around">
                    <div className="col-md-10">
                        <CustomRow className="row justify-content-center">
                            <div className="col-md-12">
                                <PTitle>
                                    <Translate value="leaseApplication.paragraphs.one.header" />
                                </PTitle>
                                <PDescription>
                                    <Translate value="leaseApplication.paragraphs.one.description1" /> <span className="type--italic"><Translate value="leaseApplication.paragraphs.one.description2" /></span> <Translate value="leaseApplication.paragraphs.one.description3" />
                                </PDescription>
                            </div>
                        </CustomRow>
                        <CustomRow className="row justify-content-center">
                            <div className="col-md-12">
                                <PTitle>
                                    <Translate value="leaseApplication.paragraphs.two.header" />
                                </PTitle>
                                <PDescription>
                                    <Translate value="leaseApplication.paragraphs.two.description" />
                                </PDescription>
                            </div>
                        </CustomRow>
                        <CustomRow className="row justify-content-center">
                            <div className="col-md-12">
                                <PTitle>
                                    <Translate value="leaseApplication.paragraphs.three.header" />
                                </PTitle>
                                <PDescription>
                                    <Translate value="leaseApplication.paragraphs.three.description" />
                                </PDescription>
                            </div>
                        </CustomRow>

                        {showLink &&
                        <CustomRow className="row justify-content-center" style={{ marginTop: 20 }}>
                            <div className="col-md-12 text-center">
                                <Button type="button" className="btn btn--primary type--uppercase" onClick={this.onLinkClick.bind(this)}><Translate value="leaseApplication.applyBtn" /></Button>
                                <Button type="button" className="btn btn--primary type--uppercase" onClick={this.onLinkClickCan.bind(this)}><Translate value="leaseApplication.applyBtnCan" /></Button>
                            </div>
                        </CustomRow>
                        }

                        <CustomRow className="row justify-content-center" style={{ marginTop: 20 }}>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-6 text-center">
                                        <span className="type--fine-print"></span>
                                    </div>
                                </div>
                                <CustomRow className="row justify-content-center"></CustomRow>
                                <div className="row">
                                    <div className="col-6 text-center">
                                        <span className="type--fine-print">
                                            <Link to={Constants.ENDPOINTS.PAYMENT_OPTIONS}>Learn More</Link>
                                        </span>
                                    </div>
                                    <div className="col-6 text-center">
                                        <span className="type--fine-print">
                                        <Link to={Constants.ENDPOINTS.LEASING_FAQS}>Leasing FAQs</Link>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </CustomRow>
                    </div>
                </div>
            </form>
        );
    }
}

DocuSign.propTypes = {
    getXsrfToken: PropTypes.func,
    logout: PropTypes.func,
    getOrderSummary: PropTypes.func,
    applyForLease: PropTypes.func,
    userInfo: PropTypes.object,
    orderSummary: PropTypes.object,
    isWizard: PropTypes.bool,
    config: PropTypes.object,
    history: PropTypes.object
};

function mapStateToProps(state) {
    return {
        config: state.config,
        userInfo: state.userInfo,
        orderSummary: state.orderSummary
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        logout: logout,
        getOrderSummary: getOrderSummary,
        applyForLease: applyForLease
    }, dispatch);
}

export default reduxForm({
    form: "CheckoutForm",
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(DocuSign))
);